export function removeCookie(name) {
    document.cookie = encodeURIComponent((name || '').toString()) + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax';
};

export function getCookie(name) {
    name = encodeURIComponent((name || '').toString());

    var cookies = document.cookie.split(';'),
        cookiesLength = cookies.length;

    for(var i = 0; i < cookiesLength; ++i) {
        var parts = cookies[i].trim().split('=', 2);
        if(parts[0] === name)
            return decodeURIComponent(parts[1]);
    }

    return undefined;
};

export function setCookie(name, value) {
    name = encodeURIComponent((name || '').toString());
    value = encodeURIComponent((value || '').toString());

    if(getCookie(name))
        removeCookie(name);

    var life = new Date();
    life.setFullYear(life.getFullYear() + 1);
    document.cookie = name + '=' + value + '; Path=/; Expires=' + life.toUTCString() + '; SameSite=Lax';
};
